import { render, staticRenderFns } from "./MarketingStories.vue?vue&type=template&id=621f4f24&"
import script from "./MarketingStories.vue?vue&type=script&lang=js&"
export * from "./MarketingStories.vue?vue&type=script&lang=js&"
import style0 from "./MarketingStories.vue?vue&type=style&index=0&id=621f4f24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports